import {
  GET_CONFIGURATION_BY_COMPANY_ID,
  GET_CONFIGURATION_WITH_SETTING_DATA,
  GET_ACTIVITY_CONFIGURATION_SETTING_MAPPING,
  GET_HEADERNAME_BY_COMPANY_ID,
  STORE_CONFIGURATION_ID,
  REMOVE_CONFIGURATION_ID,
  SET_WORKFLOW,
} from "../constants";
import { ApiCall } from "../../utils/index"

// Integrating API's for index page
export const getConfigurationData = (request, debouncedHandleSearch, page, sortField, sortOrder, row_count) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    let url = "/configurations/company"

    if(page) {
      const searchParam = debouncedHandleSearch ? `search=${debouncedHandleSearch}&` : "";
      const params = `?${searchParam}page=${page}&page_size=${row_count}&sort_by=${sortField}&sort_order=${sortOrder}`;
      url = url + params
    }

    const result = await ApiCall.get(url, token);
    dispatch({
      type: GET_CONFIGURATION_BY_COMPANY_ID,
      payload: result.data,
    });
    request.onSuccess();
  } catch (error) {
    request?.onError();
  }
};

export const handleDeleteConfiguration =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.delete(`/configurations/${request.config_id}`, token);
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const getConfigurationDataWithSetting =
  (request) => async (dispatch, getState) => {
    try {
      console.log('action called for config')
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/configurations/withsettings/${request.configurationID}`, token);
      dispatch({
        type: GET_CONFIGURATION_WITH_SETTING_DATA,
        payload: result.data,
      });
      if(request.onSuccess){
        request.onSuccess(result.data)
      }
    } catch (error) {
      request.onError();
    }
  };

export const getActivityConfigurationSettingMapping =
  (request) => async (dispatch, getState) => {
    const {
      auth: { token },
    } = getState();
    try {
      const result = await ApiCall.get(`/configurationsSettingMapping/configuration/${request.configuration_id}`, token);
      dispatch({
        type: GET_ACTIVITY_CONFIGURATION_SETTING_MAPPING,
        payload: result.data,
      });
      request.onSuccess(result.data)
    } catch (error) {
      console.log('error -', error);
      request.onError();
    }
  };

export const getHeaderName = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/configurationsSettings/company`, token);
    dispatch({ type: GET_HEADERNAME_BY_COMPANY_ID, payload: result.data });
  } catch (error) {
    request.onError();
  }
};

export const createConfiguration = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/configurations/withsettings", request.body, token);
    dispatch({
      type: STORE_CONFIGURATION_ID,
      payload: result.data,
    });
    request.onSuccess();
  } catch (error) {
   
    request.onError(error);
  }
};

export const createConfigurationSettingMappingBulk =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post("/configurationsSettingMapping/bulk",  request.body, token);
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const handleDeleteConfigurationSetting =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.delete(`/configurationsSettings/${request.id}`, token);
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const handleUpdateConfigurationSetting =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.patch(`/configurationsSettings/${request.toBeEdited}`, request.body, token)
      request.onSuccess();
    } catch (error) {
      console.log('error ---', error)
      request.onError();
    }
  };

export const handleAddHeader = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, company },
    } = getState();
    const result = await ApiCall.post("/configurationsSettings/",  request.body, token);
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const handleUpdateConfigurationName =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.patch(`/configurations/${request.configurationID}`, request.body, token)
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const createAndUpdateConfigurationSettingMappingBulk = (request) => async (dispatch, getState) => {
  try {
    const {auth: {token, company}} = getState();
    const result = await ApiCall.post("/configurationsSettingMapping/bulkCreateOrUpdate", request.body, token);
    request.onSucess()
  } catch (error) {
    request.onError()
  }
}

export const deleteConfigurationSettingMapping = (request) => async(dispatch, getState) => {
  try {
    const {auth: {token, company}} = getState();
    const result = await ApiCall.delete(`/configurationsSettingMapping/${request.id}`, token);
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
}

export const getWorkflowById = (request) => async(dispatch, getState) => {
  try {
    const { auth: { token }} = getState();
    const result = await ApiCall.get(`/configurations/workflow/${request.id}`, token);

    dispatch({
      type: SET_WORKFLOW,
      payload: result.data
    })
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
}

export const createWorkflow = (request) => async(dispatch, getState) => {
  try {
    const { auth: { token }} = getState();
    const result = await ApiCall.post(`/configurations/workflow`, request.payload, token);
    request.onSuccess(result);
  } catch (error) {
    request.onError(error);
  }
}
